import React from 'react';
import FieldsWrapper from './Fields/FieldsWrapper';
import UploadFieldDemo from './Fields/UploadFieldDemo';
import ComboBoxDemo from './Fields/ComboBoxDemo';
import CheckBoxDemo from './Fields/CheckBoxDemo';
import InputFieldDemo from './Fields/InputFieldDemo';
import DatePickerDemo from './Fields/DatePickerDemo';
import RadioGroupDemo from './Fields/RadioGroupDemo';
import SelectDemo from './Fields/SelectDemo';

const FieldsDemoContainer = () => {
  return (
    <FieldsWrapper>
      <InputFieldDemo />
      <ComboBoxDemo />
      <SelectDemo />
      <DatePickerDemo />
      <CheckBoxDemo />
      <RadioGroupDemo />
      <UploadFieldDemo />
    </FieldsWrapper>
  );
};

export default FieldsDemoContainer;
